import { DatabaseBackup, FileSpreadsheet, RefreshCw } from "lucide-react";
import { useState } from "react";
import { api } from "../api";

export function OperationsPage() {
  const [working, setWorking] = useState("");
  const [message, setMessage] = useState("");

  async function run(kind: "export" | "backup") {
    setWorking(kind);
    setMessage("");
    try {
      const result = kind === "export" ? await api.runExport() : await api.runBackup();
      setMessage(`${kind === "export" ? "Export" : "Backup"} completed: ${result.path}`);
    } catch (reason) {
      setMessage(reason instanceof Error ? reason.message : `${kind} failed`);
    } finally {
      setWorking("");
    }
  }

  return (
    <div className="page narrow-page">
      <div className="page-heading">
        <div>
          <h1>Exports & backups</h1>
          <p>The SQLite database stays authoritative. Spreadsheet failures never block inventory work.</p>
        </div>
      </div>
      <div className="operation-list">
        <section>
          <FileSpreadsheet />
          <div>
            <h2>Excel and CSV inventory</h2>
            <p>Regenerate the formatted workbook and all current CSV files atomically.</p>
            <code>Local data folder\exports\current\Master_Inventory.xlsx</code>
          </div>
          <button className="button primary" onClick={() => run("export")} disabled={!!working}>
            {working === "export" ? <RefreshCw className="spin" /> : <FileSpreadsheet />}
            Export now
          </button>
        </section>
        <section>
          <DatabaseBackup />
          <div>
            <h2>Checked local backup</h2>
            <p>Export first, then copy database, photos, JSON, configuration, and reports with SHA-256 manifest.</p>
            <code>Local data folder\backups\manual</code>
          </div>
          <button className="button primary" onClick={() => run("backup")} disabled={!!working}>
            {working === "backup" ? <RefreshCw className="spin" /> : <DatabaseBackup />}
            Back up now
          </button>
        </section>
      </div>
      {message && <div className="alert info path-message">{message}</div>}
    </div>
  );
}
